module.exports = {
	"articleTitle1": "New luxury apartments open doors to students",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Neopapalis",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/arts/best-ann-arbor-2013-list",
	"articleSnippet1": "Sep 5, 2012 ... ... the first floor and the attached indoor parking complex, Zaragon West has \nleased first-floor space to NeoPapalis, an Italian style restaurant.",
	"articleSnippet2": "Apr 17, 2013 ... Winner: Kang's Korean Restaurant Runner-up: Rod's. Best New Restaurant \nWinner: NeoPapalis. Runner-up: RUB BBQ. Best Tanning Salon",
	"foodRecommendations": [
		{
			"text": "Hot, fast, and tasty, what more can you ask of pizza?",
			"person": "Nick Kortman"
		}
	],
	"articleTitle2": "Best of Ann Arbor 2013",
	"address": "500 E William St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.277533,
		"lng": -83.742886
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/neopapalis.json
// module id = 932
// module chunks = 0